import PrivacyPolicyCheck from './ui/PrivacyPolicyCheck.vue'

export * from './model'

export {
  PrivacyPolicyCheck
}
